/**************************************************
 * Nombre:       Tarjeta_Black
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useNavigate} from "react-router";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Black = () => {
    const navigate = useNavigate();
    const {sCell, masSM, sTab} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#ffffff30',
                backdropFilter: 'blur(6px)',
                borderTopLeftRadius: 16,
                borderBottomLeftRadius: 16,
                border: 1,
                borderColor: '#ffffff10',
                p: !masSM ? 4 : 6,
                color: '#fff',
                ml: sCell ? 3 : 0
            }}
            spacing={!masSM ? 0 :  6}
        >

            <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: sCell ? 32 : 60, fontWeight: 800, color: '#fff'}}>
                    Black Days
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={sCell ? 'flex-start' : 'flex-end'}
                    spacing={0}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: sCell ? 16 : 24, fontWeight: 600}}>Del 24 al 30 de
                            Noviembre</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: sCell ? 0 : 2}}>
                        <Typography sx={{fontSize: sCell ? 38 : 60, fontWeight: 800, lineHeight: 1.1}}>20%
                            OFF</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: sCell ? 28 : 44, fontWeight: 800, lineHeight: 1.1}}>EN TODA LA
                            TIENDA</Typography>
                    </Grid>

                    <Grid container size={{xs: 8, sm: 8, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 2 : 4}}>
                        <Button
                            onClick={() => navigate('/Todos')}
                            sx={{backgroundColor: '#000'}}>Comprar ahora</Button>
                    </Grid>

                    <Grid container size={{xs: 4, sm: 4, md: 8}} sx={{justifyContent: 'flex-end', mt: sCell ? 2 : 0}}>
                        <Typography>Aplican TyC.</Typography>
                    </Grid>


                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Black    